export const MAINTENANCE_MESSAGE =
  "Our service is temporarily unavailable due to maintenance. Please try again shortly.";

export const isMaintenanceStatus = (status) =>
  [502, 503, 504].includes(Number(status));

export const isNetworkUnavailableError = (err) => {
  const message = String(err?.message || "").toLowerCase();
  return (
    message.includes("failed to fetch") ||
    message.includes("load failed") ||
    message.includes("networkerror") ||
    message.includes("network request failed")
  );
};

export const toFriendlyErrorMessage = (err, fallbackMessage) => {
  if (String(err?.message || "") === MAINTENANCE_MESSAGE || isNetworkUnavailableError(err)) {
    return MAINTENANCE_MESSAGE;
  }

  return fallbackMessage || "Something went wrong. Please try again.";
};

